<template>
  <div class="terms">
    <HeaderComponent/>
    <Terms/>
    <FooterComponent/>
  </div>
</template>

<script>
import HeaderComponent from '@/components/HeaderPayment';
import Terms from '@/components/Terms';
import FooterComponent from '@/components/Footer.vue';
export default {
  name: "TermsAndCondition",
  components: {
    HeaderComponent,
    Terms,
    FooterComponent,
  }
}
</script>

<style scoped>

</style>